import React from "react";
import Logo from "../components/Logo";
import LoginForm from "../components/LoginForm";

const Login = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-red-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8">
        {/* Logo and Branding */}
        <div className="text-center space-y-2">
          <div className="mx-auto w-16 h-16 shadow-xl rounded-lg flex items-center justify-center mb-4">
            <Logo />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">BVN Portal</h1>
        </div>

        {/* Login Form */}
        <LoginForm />

        {/* Footer */}
        <div className="text-center space-y-2">
          <div className="flex justify-center space-x-4 text-xs text-gray-500">
            <span>© {new Date().getFullYear()} BVN Portal</span>
            <span>•</span>
            <span>Internal Use Only</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
